export default __webpack_public_path__ + "static/media/102.d34fd5fc.jpg";